// extracted by mini-css-extract-plugin
module.exports = {"container":"VaultBenefits_container__4Vd_0"};